import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'bepatient-change-password-success-popup',
  templateUrl: './change-password-success-popup.component.html',
  styleUrls: ['./change-password-success-popup.component.scss'],
  standalone: false
})
export class ChangePasswordSuccessPopupComponent {
  @Input() color: string;
  @Input() message: string;
  @Input() buttonLabel: string;
  @Output() validated = new EventEmitter<boolean>();
}
